import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import {logout, onForbidden} from '../account/login';
import {getCurrentGroup} from "../account/role";
import _ from 'lodash';
import moment from 'moment';
import {getTranslation} from "../common/localization";
import { hideModal } from '../common/activeModal';

const MAX_FILE_SIZE = 104857600;

//- Actions
export const uploadBulkAccreditationsAsFile = (data) => (dispatch, getState) => {
    dispatch(fetchSubmitForm());

    if (data.get('file').size > MAX_FILE_SIZE) {
        dispatch(fetchSubmitFormFailed(_.get(getTranslation(getState()), 'bulk_upload.exceeded_upload_size_alert')));
    } else {
        let groupId = getCurrentGroup(getState());
        data.append('accredGroupId', groupId);
        dispatch(fetchUploadBulkAccreditationsAsFile(data));
    }
};
export const fetchUploadBulkAccreditationsAsFile = createAction(
    'FETCH_BULK_ACCREDITATIONS_UPLOAD',
    (groupId, data) => Api.fetchUploadBulkAccreditationsAsFile(groupId, data),
    () => ({
        apiCall: true,
        onSuccess: fetchUploadBulkAccreditationsSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const uploadBulkAccreditationsAsJSON = (data) => (dispatch, getState) => {
    dispatch(fetchSubmitForm());
    dispatch(hideModal());
    let groupId = getCurrentGroup(getState());
    data['accreditationGroupId'] = groupId;
    dispatch(fetchUploadBulkAccreditationsAsJSON(data));
};
export const fetchUploadBulkAccreditationsAsJSON = createAction(
    'FETCH_BULK_ACCREDITATIONS_UPLOAD',
    (groupId, data) => Api.fetchUploadBulkAccreditationsAsJSON(groupId, data),
    () => ({
        apiCall: true,
        onSuccess: fetchUploadBulkAccreditationsSuccess,
        onFail: fetchUploadBulkAccreditationsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchUploadBulkAccreditationsSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(getJobs())
};

export const fetchUploadBulkAccreditationsFailed = (error) => (dispatch) => {
    switch (error) {
        case "REQUEST_BODY_INVALID":
            dispatch(fetchSubmitFormFailed("INCORRECT_FILE_CONTENT"));
            break;

        default:
            dispatch(fetchSubmitFormFailed(error));
            break;
    }
};

export const getJobs = () => (dispatch, getState) => {
    let groupId = getCurrentGroup(getState());
    if (!_.isNil(groupId)) {
        dispatch(fetchGetJobs(groupId))
    }
};

export const fetchGetJobsSuccess = createAction('FETCH_GET_JOBS_SUCCESS');
export const fetchGetJobsFailed = createAction('FETCH_GET_JOBS_FAILED');
export const fetchGetJobs = createAction(
    'FETCH_GET_JOBS',
    (groupId) => Api.getBulkJobs(groupId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetJobsSuccess,
        onFail: fetchGetJobsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchRemoveBulk = createAction(
    'FETCH_REMOVE_BULK',
    (bulkId) => Api.removeBulk(bulkId),
    () => ({
        apiCall: true,
        onSuccess: getJobs,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
};

//- Reducers
export default handleActions({
    FETCH_GET_JOBS: (state) => {
        return {...state, fetching: true, error: null};
    },
    FETCH_GET_JOBS_SUCCESS: (state, action) => {
        return {...state, fetching: false, error: null, data: action.payload}
    },
    FETCH_GET_JOBS_FAILED: (state, action) => {
        return {...state, fetching: false, error: action.payload, data: null}
    }
}, initialState);

//- Selectors
export const getBulk = state => state.bulk;

export const loadingBulkJobs = state => getBulk(state).fetching;

export const getBulkJobs = state => getBulk(state).data;

export const getBulkJobsFormattedData = state => {
    return _.map(getBulkJobs(state), jobData => ({
            id: jobData.id,
            fileName: jobData.fileName,
            createdAt: moment(jobData.createdAt).format("MMMM Do YYYY, HH:mm"),
            processedPersent: Math.floor(jobData.processedEntriesCount / jobData.totalEntriesCount * 100),
            processedEntriesCount: jobData.processedEntriesCount,
            totalEntriesCount: jobData.totalEntriesCount,
            finished: jobData.finished,
            globalError: jobData.finished && jobData.processedEntriesCount < jobData.totalEntriesCount,
            errors: _.chain(jobData.errors)
                .map(error => error.split(':')[1].trim())
                .uniq()
                .value()
        })
    )
};



// WEBPACK FOOTER //
// ./src/reducers/accreditation/bulk.js